import type { IProyecto } from "./entidades/IProyecto";
import type { IRespuestaApiLista, IRespuestaApiObjeto } from "../../globales/interfaces";
import api from "../../utils/api";

export class ProyectoModelo {
    

    constructor() { }
    public async obtenerListaProyectos(nit: string): Promise<IRespuestaApiLista<IProyecto>> {
        const { data } = await api.get(
            `/api/Proyectos/Listar`, {
            headers: {
                "Content-Type": "application/json",
                
            },
            params: {
                nit: nit
            }
        });
        return data;
    }

    public async crearProyecto(proyecto: IProyecto): Promise<IRespuestaApiObjeto<IProyecto>> {
        const { data } = await api.post(
            `/api/Proyectos/Crear`, proyecto, {
            headers: {
                "Content-Type": "application/json",
                
            },
        });
        return data;
    }

    public async editarProyecto(proyecto: IProyecto): Promise<IRespuestaApiObjeto<IProyecto>> {
        const { data } = await api.put(
            `/api/Proyectos/Actualizar`, proyecto, {
            headers: {
                "Content-Type": "application/json",
                
            },
        });
        return data;
    }

    public async eliminarProyecto(proyecto: IProyecto): Promise<IRespuestaApiObjeto<boolean>> {
        const { data } = await api.delete(
            `/api/Proyectos/Eliminar/${proyecto.Id}`, {
            headers: {
                "Content-Type": "application/json",
                
            },
        });
        return data;
    }

    
}

